"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.NUMBER_REGEX_PATTERN = void 0;
exports.setNumberRegex = setNumberRegex;
let NUMBER_REGEX_PATTERN = exports.NUMBER_REGEX_PATTERN = null;

/**
 * Allows the consuming app to have some control over number formatting,
 * e.g. valid decimal characters
 * @param   {RegExp|string}  numberRegexPattern
 * @returns {RegExp|null}
 */
function setNumberRegex(numberRegexPattern) {
  if (numberRegexPattern === undefined || numberRegexPattern === null) {
    exports.NUMBER_REGEX_PATTERN = NUMBER_REGEX_PATTERN = null;
    return NUMBER_REGEX_PATTERN;
  }
  exports.NUMBER_REGEX_PATTERN = NUMBER_REGEX_PATTERN = new RegExp(numberRegexPattern);
  return NUMBER_REGEX_PATTERN;
}